module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs--half a-form-inputs--half-to"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__to"
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('date-input', {
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41ed2ede!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/form/Dates.vue
// module id = 1662
// module chunks = 0